import { SMSIconFilled } from '@rsos/assets/icons';
import { LocationSources, SOURCE_TCAPI } from '@rsos/constants/locationSources';
import type { conversationStateValues } from '@rsos/reduxDataStore/src/features/conversations/conversations.typings';

export const TT911_MESSAGE = 'Text-to-911 Message: Inbound Emergency Request';

export function getToastMessage(
  conversation: conversationStateValues | undefined,
): string | null {
  if (!conversation?.source) return null;

  if (conversation.source === SOURCE_TCAPI) {
    if (conversation.transfer?.status === 'pending') {
      if (conversation.transfer.initiatingAuthorityDisplayName) {
        return `${conversation.transfer.initiatingAuthorityDisplayName} has transferred a text conversation to you.`;
      }
      return 'A text conversation has been transferred to you.';
    }
    return TT911_MESSAGE;
  }

  return null;
}

export const getToastIcon = () => {
  return <SMSIconFilled data-name="conversations-toast-sms-icon" />;
};

export const getToastButtonText = (source: LocationSources) => {
  if (source === SOURCE_TCAPI) {
    return 'Accept';
  }

  return 'View';
};
